import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useCampaign } from "./CampaignContext";
import CharacterSheetsStack from "../CharacterSheets/CharacterSheetsStack";

function hasPillar(pillars, name) {
  const list = Array.isArray(pillars) ? pillars : [];
  const n = String(name || "").trim().toLowerCase();
  return list.some((p) => String(p).trim().toLowerCase() === n);
}

export default function DepartingSurvivors() {
  const nav = useNavigate();
  const { current, updateSurvivor } = useCampaign();

  const pillars = current?.pillars || [];
  const useArc = hasPillar(pillars, "arc survivors");

  const survivors = Array.isArray(current?.survivors) ? current.survivors : [];
  const departingIds = Array.isArray(current?.departingSurvivorIds)
    ? current.departingSurvivorIds
    : [];

  const departingSurvivors = useMemo(
    () => survivors.filter((s) => departingIds.includes(s.id)),
    [survivors, departingIds]
  );

  if (!current?.settlementName) {
    return (
      <div style={{ padding: 16 }}>
        <h2>Departing Survivors</h2>
        <div style={{ opacity: 0.85 }}>No campaign loaded.</div>
        <div style={{ marginTop: 12 }}>
          <button onClick={() => nav("/load")}>Go to Load Campaign</button>
        </div>
      </div>
    );
  }

  const campaignKeyBase = `kdm__campaign__${current.id || current.settlementName}`;

  return (
    <div style={{ padding: 16 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <h2 style={{ margin: 0 }}>Departing Survivors</h2>
        <button style={{ marginLeft: "auto" }} onClick={() => nav("/settlement")}>
          Back to Settlement Sheet
        </button>
      </div>

      <div style={{ marginTop: 10, opacity: 0.85 }}>
        Settlement: <b>{current.settlementName}</b>
      </div>

      <div style={{ marginTop: 14 }}>
        {departingSurvivors.length === 0 ? (
          <div style={{ opacity: 0.8 }}>No departing survivors selected.</div>
        ) : (
          <CharacterSheetsStack
            initialType={useArc ? "arc" : "character"}
            survivors={departingSurvivors}
            campaignKeyBase={campaignKeyBase}
            onSetColor={(id, color) => updateSurvivor(id, { borderColor: color })}
            showColorPicker={true}
            borderWidth={8}
          />
        )}
      </div>
    </div>
  );
}